// Copyright 2025-2026 NXGN Management, LLC. All Rights Reserved.
import LayoutWithProvider from '@/app/shared/components/Layout'

export default function AuthenticatedApp() {
  return <LayoutWithProvider />
}
